"use client";

import { motion } from "framer-motion";
import { GraduationCap, LineChart } from "lucide-react";
import { trackCTAClick } from "@/app/lib/analytics";

const COMING = [
  {
    icon: <LineChart size={22} />,
    label: "Inversiones",
    blurb:
      "Acciones, bonos, CEDEARs y FCIs directamente desde la app. Sin necesidad de ser experto y sin montos mínimos altos.",
    eta: "2027",
  },
  {
    icon: <GraduationCap size={22} />,
    label: "Educación financiera",
    blurb:
      "Charlas en colegios, cursos gratuitos y contenido integrado. La idea es que entender de plata no sea solo para los que ya saben.",
    eta: "En curso",
  },
];

export default function ComingSoonSection() {
  return (
    <section
      id="lo-que-viene"
      data-section="section-coming"
      className="relative py-24 sm:py-36"
      aria-label="Lo que viene"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div data-particle-shield className="mb-14 max-w-3xl">
          <div className="text-[12px] tracking-[0.2em] uppercase text-white/40 mb-5">
            Lo que viene
          </div>
          <h2 className="text-[clamp(36px,5.5vw,72px)] font-extrabold leading-[1.05] tracking-tight">
            Hoy, gastos.{" "}
            <br className="hidden sm:block" />
            Mañana, <span className="gradient-text">inversiones.</span>
          </h2>
          <p className="text-white/55 mt-5 text-lg sm:text-xl max-w-2xl leading-relaxed">
            Finbo se construye con foco. Lanzamos primero lo más urgente: que
            entiendas tu plata. El resto del producto ya está en camino.
          </p>
        </div>

        <div data-particle-shield className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-12">
          {COMING.map((c, i) => (
            <motion.div
              key={c.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 }}
              className="gradient-border"
            >
              <div className="gradient-border-inner p-7 sm:p-9 h-full flex flex-col">
                <div className="flex items-center justify-between mb-5">
                  <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-primary">
                    {c.icon}
                  </div>
                  <span className="text-[11px] tracking-[0.2em] uppercase text-white/40">
                    {c.eta}
                  </span>
                </div>
                <h3 className="text-3xl font-bold text-white mb-3 tracking-tight">
                  {c.label}
                </h3>
                <p className="text-white/55 leading-relaxed">{c.blurb}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Waitlist CTA */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          data-particle-shield
          className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5 p-7 rounded-2xl border border-white/[0.06] bg-ink-850/60 backdrop-blur-sm"
        >
          <div>
            <div className="text-white/85 font-medium mb-1">
              ¿Querés ser de los primeros en probar las inversiones?
            </div>
            <p className="text-sm text-white/45">
              Escribinos un mail y te avisamos cuando abramos el acceso anticipado.
            </p>
          </div>
          <a
            href="mailto:finbo.ad@gmail.com?subject=Acceso%20anticipado%20a%20inversiones&body=Hola%20Finbo%2C%0A%0AMe%20gustar%C3%ADa%20probar%20las%20inversiones%20cuando%20est%C3%A9n%20disponibles.%0A%0AGracias.%0A"
            className="btn-primary whitespace-nowrap"
            onClick={() => trackCTAClick("waitlist_email", "coming_soon")}
          >
            Sumarme a la lista
          </a>
        </motion.div>
      </div>
    </section>
  );
}
